import { render } from "./WalletEditForm.vue?vue&type=template&id=ef647bf8"
import script from "./WalletEditForm.vue?vue&type=script&lang=js"
export * from "./WalletEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__